import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
import useFakeCalendarData from '@/Shared/Hook/useFakeCalendarData'
import {
    type AvailabilityResultDateType,
    type CalendarMonthType,
} from '@/Shared/AutoGenerated/Main'

export default class AvailabilityResult {
    constructor(
        public readonly months: CalendarMonthType[],
        public readonly availabilityResultDate: AvailabilityResultDateType[],
    ) {
        ensureNoUndefinedProperties(this)
    }

    static newEmpty = (): AvailabilityResult => {
        const fakeCalendarData = useFakeCalendarData().get()

        return new AvailabilityResult(fakeCalendarData.months, [])
    }

    getAvailabilityResultDate = (
        rawDate: string,
    ): AvailabilityResultDateType => {
        const availableDateWithTimeSlots = this.availabilityResultDate.find(
            (availabilityResultDate: AvailabilityResultDateType) => {
                return (
                    availabilityResultDate.dateInSelectedTimeZoneForDisplay ===
                    rawDate
                )
            },
        )

        if (!availableDateWithTimeSlots) {
            throw new Error('Date without timeslots', {
                cause: {
                    months: this.months,
                    availabilityResultDate: this.availabilityResultDate,
                    rawDate: rawDate,
                },
            })
        }

        return availableDateWithTimeSlots
    }
}
